import React from 'react';
import PropTypes from 'prop-types';
import css from './index.scss';

const Modal = (props) => {
    let backdropClass = css.modalBackdrop;
    let modalClass = css.modal;

    if (props.smallMode) {
        backdropClass = css.modalBackdropSmall;
        modalClass = css.modalSmall;
    }

    const modalElement = props.show
        ?
        (<div className={backdropClass}>
            <div className={modalClass}>
                {props.children}
            </div>
        </div>)
        : null;

    return modalElement;
};

Modal.propTypes = {
    show: PropTypes.bool,
    smallMode: PropTypes.bool,
    children: PropTypes.node
};

export default Modal;



// WEBPACK FOOTER //
// ./app/components/modal/index.js